import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledFilter } from "./filter.scss";
import { useState } from "react";
import classnames from "classnames";
import { FILTER_CLICKED, FILTER_CHOICE_CLICKED } from "constants/bigbrain-event-types";
import { trackEvent } from "/services/bigbrain-service";
import DownArrow from "/static/svg/arrow-down.svg";
import ViSign from "/static/svg/vi_icon.svg";
import CloseIcon from "static/svg/close.svg";
import { getFilterIcon } from "components/pages/whats-new/utils";
import { generateOnKeyDownHandler } from "/client/services/accessibility/accessibility-service";
import { NON_PLATFORMIC_PRODUCT_IDS, PLATFORM_PRODUCT_ID } from "/constants/products";
const Filter = ({ title, values, data, onChange, isOpen, onToggle, hideProductFilter })=>{
    var _data_selectedValues_;
    const [selectedValues, setSelectedValues] = useState(values);
    const PRODUCT_ID = "product";
    const toggleSelect = ()=>{
        if (!isOpen) {
            trackEvent(FILTER_CLICKED, {
                kind: title
            });
        }
        onToggle();
    };
    const updateSelectedValues = (newSelectedValues)=>{
        setSelectedValues(newSelectedValues);
        if (onChange) onChange(newSelectedValues);
    };
    const handleSelect = (value, isDisabled)=>{
        if (isDisabled) return;
        trackEvent(FILTER_CHOICE_CLICKED, {
            kind: title,
            info1: value
        });
        let newSelectedValues;
        if (selectedValues.includes(value)) {
            newSelectedValues = selectedValues.filter((v)=>v !== value);
        } else {
            newSelectedValues = [
                ...selectedValues,
                value
            ];
        }
        // Handle special case for product filter
        if (title.toLowerCase() === PRODUCT_ID) {
            // First we check If non platformic product is selected
            let selectedWithoutPlatform = newSelectedValues.filter((selectedValue)=>selectedValue !== PLATFORM_PRODUCT_ID);
            const hasPlatformicProductSelected = selectedWithoutPlatform.some((selectedValue)=>!NON_PLATFORMIC_PRODUCT_IDS.includes(selectedValue));
            // If Only platform product is selected we add it
            const noOtherSelections = !selectedValues.some((selectedValue)=>!NON_PLATFORMIC_PRODUCT_IDS.includes(selectedValue) && selectedValue !== PLATFORM_PRODUCT_ID);
            const wasManuallySelectedPlatform = selectedValues.includes(PLATFORM_PRODUCT_ID) && noOtherSelections;
            const manuallySelectingNow = value === PLATFORM_PRODUCT_ID;
            // If non platformic product is selected we need to add monday-platform to the filter
            if (hasPlatformicProductSelected) {
                if (!newSelectedValues.includes(PLATFORM_PRODUCT_ID)) {
                    newSelectedValues.push(PLATFORM_PRODUCT_ID);
                }
            } else {
                if (!manuallySelectingNow && !wasManuallySelectedPlatform) {
                    newSelectedValues = selectedWithoutPlatform;
                }
            }
        }
        updateSelectedValues(newSelectedValues);
    };
    const handleRemoveValue = (value)=>{
        setSelectedValues(selectedValues.filter((v)=>v !== value));
        onChange(selectedValues.filter((v)=>v !== value));
    };
    const checksIfIsDisabled = (optionId)=>{
        return title.toLowerCase() === PRODUCT_ID && optionId === PLATFORM_PRODUCT_ID && selectedValues.includes(PLATFORM_PRODUCT_ID) && selectedValues.some((selectedValue)=>selectedValue !== PLATFORM_PRODUCT_ID && !NON_PLATFORMIC_PRODUCT_IDS.includes(selectedValue));
    };
    const isSelected = selectedValues && selectedValues.length > 0;
    return /*#__PURE__*/ _jsx(StyledFilter, {
        className: classnames("filter", {
            open: isOpen,
            hide: hideProductFilter
        }),
        children: /*#__PURE__*/ _jsxs("div", {
            className: classnames("filter-value", {
                selected: isSelected,
                open: isOpen
            }),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "select-container",
                    onClick: toggleSelect,
                    tabIndex: 0,
                    onKeyDown: generateOnKeyDownHandler(()=>{
                        toggleSelect();
                    }),
                    role: "button",
                    "aria-haspopup": "listbox",
                    "aria-expanded": isOpen,
                    children: [
                        (selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.length) > 0 ? /*#__PURE__*/ _jsxs("div", {
                            className: "selected-values",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "filter-selected",
                                    children: [
                                        (_data_selectedValues_ = data[selectedValues[0]]) === null || _data_selectedValues_ === void 0 ? void 0 : _data_selectedValues_.name,
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "close-button",
                                            onClick: ()=>{
                                                handleRemoveValue(selectedValues[0]);
                                            },
                                            tabIndex: 0,
                                            onKeyDown: generateOnKeyDownHandler(()=>{
                                                handleRemoveValue(selectedValues[0]);
                                            }),
                                            "aria-label": "Remove value",
                                            role: "button",
                                            children: /*#__PURE__*/ _jsx(CloseIcon, {})
                                        })
                                    ]
                                }, selectedValues[0]),
                                selectedValues.length > 1 && /*#__PURE__*/ _jsxs("div", {
                                    className: "ellipsis",
                                    children: [
                                        "+ ",
                                        selectedValues.length - 1
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ _jsx("div", {
                            className: classnames("placeholder", {
                                open: isOpen
                            }),
                            children: title
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: classnames("down-arrow-wrapper", {
                                open: isOpen
                            }),
                            "aria-hidden": true,
                            children: /*#__PURE__*/ _jsx(DownArrow, {
                                className: "down-arrow"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "options-container",
                    children: Object.entries(data).map(([optionId, optionData])=>{
                        const isDisabled = checksIfIsDisabled(optionId);
                        return /*#__PURE__*/ _jsxs("div", {
                            className: classnames("option", {
                                selected: selectedValues.includes(optionId),
                                disabled: isDisabled
                            }),
                            onClick: ()=>handleSelect(optionId, isDisabled),
                            tabIndex: 0,
                            onKeyDown: generateOnKeyDownHandler(()=>handleSelect(optionId, isDisabled)),
                            role: "option",
                            "aria-selected": selectedValues.includes(optionId),
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: classnames("checkbox", {
                                        selected: selectedValues.includes(optionId)
                                    }),
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "v-sign",
                                        children: /*#__PURE__*/ _jsx(ViSign, {})
                                    })
                                }),
                                getFilterIcon(optionData.name),
                                optionData.name
                            ]
                        }, optionId);
                    })
                })
            ]
        })
    });
};
export default Filter;
